/**
 * Advanced Lazy Loading with Intersection Observer
 * Lazy loads images, iframes, and other media below the fold
 */

(function () {
    'use strict';

    // Check for Intersection Observer support
    if (!('IntersectionObserver' in window)) {
        console.warn('Intersection Observer not supported, loading all images');
        return;
    }

    // Configuration
    const config = {
        rootMargin: '50px 0px', // Start loading 50px before entering viewport
        threshold: 0.01
    };

    // Create observer
    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const element = entry.target;

                // Handle images
                if (element.tagName === 'IMG') {
                    if (element.dataset.src) {
                        element.src = element.dataset.src;
                    }
                    if (element.dataset.srcset) {
                        element.srcset = element.dataset.srcset;
                    }
                    element.classList.add('loaded');
                }

                // Handle iframes
                if (element.tagName === 'IFRAME') {
                    if (element.dataset.src) {
                        element.src = element.dataset.src;
                    }
                }

                // Handle background images
                if (element.dataset.bgImage) {
                    element.style.backgroundImage = `url(${element.dataset.bgImage})`;
                    element.classList.add('loaded');
                }

                // Stop observing this element
                observer.unobserve(element);
            }
        });
    }, config);

    // Observe all lazy-loadable elements
    function observeLazyElements() {
        // Images with data-src
        document.querySelectorAll('img[data-src]').forEach(img => {
            imageObserver.observe(img);
        });

        // Iframes with data-src
        document.querySelectorAll('iframe[data-src]').forEach(iframe => {
            imageObserver.observe(iframe);
        });

        // Elements with data-bg-image
        document.querySelectorAll('[data-bg-image]').forEach(el => {
            imageObserver.observe(el);
        });
    }

    // Initial observation
    observeLazyElements();

    // Re-observe on dynamic content load
    document.addEventListener('DOMContentLoaded', observeLazyElements);

    // Expose for manual triggering
    window.observeLazyElements = observeLazyElements;

    // Lazy loading ready
})();
